import * as React from "react";
import { Icon, Tooltip } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { FormField, useFormContext } from "@programari-limit/base-react";
import { useCallback, useEffect, useMemo } from "react";

const CellEditComp2Reserves = (props) => {
    const {
        id,
        placeholder,
        keyVal = "selectedValues",
        fieldKey, // Indica si es quantitatDevolucio o preuDevolucio
        min,
        max,
        step,
        tooltip,
    } = props;
    const { data, doFieldChange } = useFormContext();

    const dataRef = React.useRef(data);
    useEffect(() => {
        dataRef.current = data;
    }, [data]);

    const onChange = useCallback(
        (value) => {
            const currentValue = dataRef.current?.[keyVal] ?? {};
            const currentRow = currentValue?.[id] ?? {};

            const newRow = {
                ...currentRow,
                [fieldKey]: value, // Actualitza sols la propietat concreta
            };

            const newVal = {
                ...currentValue,
                [id]: newRow,
            };

            doFieldChange(keyVal, newVal);
        },
        [doFieldChange, id, fieldKey]
    );

    const value = data?.[keyVal]?.[id]?.[fieldKey];

    return useMemo(
        () => (
            <FormField
                name={keyVal}
                type="number"
                variant="standard"
                hideLabel
                inline
                InputProps={{
                    placeholder: placeholder,
                    startAdornment: (
                        <Tooltip title={tooltip ?? placeholder}>
                            <InputAdornment position="start">
                                <Icon>add_comment</Icon>
                            </InputAdornment>
                        </Tooltip>
                    ),
                }}
                value={value ?? ""}
                onChange={(value) => {
                    onChange(value);
                }}
                min={min}
                max={max}
                step={step}
            />
        ),
        [onChange, value, min, max, step]
    );
};

export default CellEditComp2Reserves;
